import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { Flex } from 'antd';
import styled from 'styled-components';
import { DivMinWidth, FlexPadStyled } from '../App';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { LogoBC } from '../components/LogoBC';
import { colors, fonts } from '../assets/constStyles';
import { ButtonMainRed } from '../components/button/ButtonMainRed';
import { paths } from '../consts';

const DivBodyPageStyled = styled.div`
  font-family: ${fonts.font3};

  * {
    font-family: inherit;
  }
`;

export const DivPaddingStyled = styled.div`
  padding: 40px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

const DivBenefitsStyled = styled.div`
  font-size: 18px;
`;

export const MembershipPage: React.FC = () => <>
        <Helmet>
            <title>MEMBERSHIP</title>
            <meta
                name="description"
                content="AWMAC - Architectural Woodwork Manufacturers Association of Canada AWARDS"
            />
            <link rel="canonical" href='https://awmacbc.com/membership'/>
        </Helmet>
            <DivMinWidth>
                <div style={{ padding: '20px' }}>
                    <FlexPadStyled vertical>
                        <LogoBC />
                    </FlexPadStyled>
                    <Flex style={{ margin: '20px 0' }}>
                        <Breadcrumbs />
                    </Flex>
                    <h1 style={{ textAlign: 'center', fontFamily: fonts.font2, marginBottom: 20 }}>JOIN AWMAC</h1>
                    <DivBodyPageStyled>
                        <DivBenefitsStyled>
                        <span>In business, trust is everything. At AWMAC, we believe you build that trust by having a
                            standard for all manufacturing activities. Becoming an AWMAC Member gives you that and
                            more.</span>
                            <p>Some of the benefits AWMAC Members receive are:</p>
                            <ul>
                                <li>Membership of an active <strong>COMMUNITY</strong> which learns and does business with
                                    each other.
                                </li>
                                <li>Industry <strong>RECOGNITION</strong> of your company and its quality.</li>
                                <li><strong>KNOWLEDGE SHARE</strong> of best practices to increase your efficiency
                                    and <strong>SUCCESS</strong>.
                                </li>
                                <li><strong>CONNECTIONS</strong> with experts and new thinking across North America.</li>
                                <li>The <strong>OPPORTUNITY</strong> to pit your work against the industry’s best of the
                                    best and take home coveted awards!
                                </li>
                            </ul>
                        </DivBenefitsStyled>
                        <DivBenefitsStyled>
                            <p>AWMAC’s British Columbia Chapter offers 4 membership categories</p>
                            <ul>
                                <li>Manufacturer Member</li>
                                <li>Supplier Member</li>
                                <li>Allied Member</li>
                                <li>Life Member</li>
                            </ul>
                            To learn more about membership with AWMAC’s British Columbia Chapter, please email <a href="mailto:info.bc@awmac.com"><span style={{ color: colors.colorRed }}> info.bc@awmac.com.</span></a>
                        </DivBenefitsStyled>
                    </DivBodyPageStyled>
                        <Flex justify={'center'} style={{ marginTop: 20 }}>
                            <ButtonMainRed route={paths.MEMBER_LISTING} text={'Member Listing'} />
                        </Flex>
                    </div>
            </DivMinWidth>
    </>;
